import { render, staticRenderFns } from "./WorkflowsComparison.vue?vue&type=template&id=683d2cda"
import script from "./WorkflowsComparison.vue?vue&type=script&lang=js"
export * from "./WorkflowsComparison.vue?vue&type=script&lang=js"
import style0 from "./WorkflowsComparison.vue?vue&type=style&index=0&id=683d2cda&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports